// Fedari partner network — single source of truth for partner names, logos,
// descriptions and URLs, reused by the /partners page and the homepage block.
// Only owner-supplied partners; do not add partnership dates, endorsements or
// project counts. Certifications (e.g. InterNACHI) are NOT partners and must
// never be added here.
export const PARTNERS = [
  {
    name: "SnagFlow",
    url: null, // no public link — owner requested no link
    label: "Technology Partner",
    logo: "/images/partners/snagflow-logo.webp",
    logoAlt: "SnagFlow logo — Snagging the Future",
    description: "Snagging the Future",
  },
  {
    name: "DXBNIC",
    url: "https://dxbnic.com",
    label: "Partner",
    logo: null, // no official logo asset available — clean text treatment
    logoAlt: "DXBNIC",
    description: null,
  },
  {
    name: "Keynes Group",
    url: "https://keynesgroupuae.com",
    label: "Partner",
    logo: "/images/partners/keynes-group-logo.webp",
    logoAlt: "Keynes Group logo",
    description: "A Dubai-based multidisciplinary group providing construction, authority approvals, design, fit-out and property support services.",
  },
];
